export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBIo-Gnt7bOdJLouRxWEeDzmBkI-h90JjY',
    authDomain: 'xpo-ltl-dev-cf3b6.firebaseapp.com',
    projectId: 'xpo-ltl-dev',
    appId: '1:339239167082:web:bc6eeb7ad303959bf29613',
  },
};
